import { type NavigationAnchor } from "@/components/layout/types";
import {
  Module,
  PATH_CONTRACTORS_PLANNED_HOURS_APPROVALS,
  PATH_LIMITS_REPORT,
  PATH_SCHEDULES_REPORT,
} from "@/constants";
import { usePermissions } from "@/modules/account/hooks/usePermissions";
import {
  FileChartColumnIncreasing,
  FileChartLine,
  FileSpreadsheet,
} from "lucide-react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useReportsMenuItems = (): NavigationAnchor[] => {
  const { t } = useTranslation();
  const permissions = usePermissions();

  return useMemo(
    () => [
      {
        icon: FileChartColumnIncreasing,
        url: PATH_SCHEDULES_REPORT,
        permission: permissions[Module.SchedulesReport].can_read,
        title: t("reports.navigation.schedulesReport"),
      },
      {
        icon: FileChartLine,
        url: PATH_LIMITS_REPORT,
        permission: permissions[Module.LimitsReport].can_read,
        title: t("reports.navigation.limitsReport"),
      },
      {
        icon: FileSpreadsheet,
        url: PATH_CONTRACTORS_PLANNED_HOURS_APPROVALS,
        permission:
          permissions[Module.ContractorsPlannedHoursApprovals].can_read,
        title: t("reports.navigation.contractorsPlannedHoursApprovals"),
      },
    ],
    [permissions, t],
  );
};
